var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { capitalize } from 'lodash';
import { isDraft } from '../../../campaign-utils';
import { DATE_TIME_COLUMN_ID, OPEN_RATE_COLUMN_ID, SALES_COLUMN_ID } from './columns/constants';
var getCustomerGroupLabel = function (campaignGroup, services, customerGroups) {
    if (['all', 'prospective', 'new', 'regular'].includes(campaignGroup.name)) {
        return "".concat(capitalize(campaignGroup.name), " Clients");
    }
    if (campaignGroup.name === 'lapsing') {
        return 'Lapsed Clients';
    }
    if (campaignGroup.name === 'service') {
        var campaignGroupService = services === null || services === void 0 ? void 0 : services.find(function (service) { return service.id === campaignGroup.serviceId; });
        return campaignGroupService ? "'".concat(campaignGroupService.name, "' Service") : null;
    }
    if (campaignGroup.name === 'barber') {
        var barberCustomerGroup = customerGroups === null || customerGroups === void 0 ? void 0 : customerGroups.find(function (customerGroup) { return customerGroup.name === 'barber' && campaignGroup.barberId === customerGroup.id; });
        return barberCustomerGroup ? "".concat(barberCustomerGroup.firstName, " ").concat(barberCustomerGroup.lastName) : null;
    }
    if (campaignGroup.name === 'shop') {
        var shopCustomerGroup = customerGroups === null || customerGroups === void 0 ? void 0 : customerGroups.find(function (customerGroup) { return customerGroup.name === 'shop' && campaignGroup.shopId === customerGroup.id; });
        return shopCustomerGroup ? shopCustomerGroup.label : null;
    }
    return 'Custom';
};
export var getEngageTableData = function (campaigns, services, customerGroups) {
    if (!campaigns) {
        return [];
    }
    return campaigns.map(function (campaign) { return (__assign(__assign({}, campaign), { formattedSubject: campaign.displayName, customerGroups: campaign.customerGroups
            .map(function (group) { return (__assign(__assign({}, group), { label: getCustomerGroupLabel(group, services, customerGroups) })); })
            .filter(function (group) { return !!group.label; }) })); });
};
export var shouldShowDateTime = function (campaign) { return !isDraft(campaign); };
export var shouldShowSales = function (campaign) { return !isDraft(campaign); };
export var shouldShowOpenRate = function (campaign) { return !isDraft(campaign); };
export var shouldShowCellData = function (cell) {
    var campaign = cell.row.original;
    if (cell.column.columnDef.id === DATE_TIME_COLUMN_ID) {
        return shouldShowDateTime(campaign);
    }
    if (cell.column.columnDef.id === SALES_COLUMN_ID) {
        return shouldShowSales(campaign);
    }
    if (cell.column.columnDef.id === OPEN_RATE_COLUMN_ID) {
        return shouldShowOpenRate(campaign);
    }
    return true;
};
